export default __webpack_public_path__ + "static/media/no-data.33651e50.png";